"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVisibilityUpdateTrackingActions = getVisibilityUpdateTrackingActions;
exports.versionGroupMadePrivate = versionGroupMadePrivate;
exports.versionGroupMadePublic = versionGroupMadePublic;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _events = require("../../events");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function versionGroupMadePublic(props) {
  var eventType = _events.EVENT_TYPES.API_VERSION_MADE_PUBLIC;
  return [eventType, props];
}
function versionGroupMadePrivate(props) {
  var eventType = _events.EVENT_TYPES.API_VERSION_MADE_PRIVATE;
  return [eventType, props];
}
function getVisibilityUpdateTrackingActions(_ref) {
  var asset = _ref.asset,
    currentVersionGroups = _ref.currentVersionGroups,
    updatedVersionGroups = _ref.updatedVersionGroups;
  var eventProps = {
    organizationId: asset.organization.id,
    groupId: asset.groupId,
    assetId: asset.assetId,
    type: asset.type
  };
  var trackingActions = [];
  currentVersionGroups.forEach(function (currentGroup) {
    var updatedGroup = updatedVersionGroups.find(function (updatedVersionGroup) {
      return currentGroup.versionGroup === updatedVersionGroup.versionGroup;
    });
    if (!updatedGroup || currentGroup.isPublic === updatedGroup.isPublic) {
      return;
    }
    if (updatedGroup.isPublic) {
      trackingActions.push(versionGroupMadePublic(_objectSpread(_objectSpread({}, eventProps), {}, {
        versionGroup: currentGroup.versionGroup
      })));
    } else {
      trackingActions.push(versionGroupMadePrivate(_objectSpread(_objectSpread({}, eventProps), {}, {
        versionGroup: currentGroup.versionGroup
      })));
    }
  });
  return trackingActions;
}
//# sourceMappingURL=utils.js.map